module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "usercenter"
  }, [_c('div', {
    staticClass: "main"
  }, [(_vm.uid == 'null' || _vm.uid == '' || _vm.uid == null) ? _c('div', {
    staticClass: "unlogin"
  }, [_c('div', {
    staticClass: "unlogin-img"
  }), _vm._v(" "), _c('p', [_vm._v("您还没有登录，请登录")]), _vm._v(" "), _c('div', {
    staticClass: "goToLogin_btn",
    on: {
      "click": _vm.toGoLogin
    }
  }, [_vm._v("登录")])]) : _c('div', [(_vm.showPage) ? _c('div', [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "logo",
    style: (_vm.userInfo.backgroundimg)
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.nickname))]), _vm._v(" "), (_vm.scoreInfo.level_pic_one) ? _c('img', {
    staticClass: "level_pic",
    attrs: {
      "src": _vm.scoreInfo.level_pic_one
    },
    on: {
      "click": function($event) {
        return _vm.toMemberLevel()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-bg"
  })]), _vm._v(" "), _c('div', {
    staticClass: "scoreInfo",
    on: {
      "click": function($event) {
        return _vm.toMyScore()
      }
    }
  }, [_c('div', {
    staticClass: "score"
  }, [_c('span', {
    staticClass: "fs-28 score_bg"
  }, [_vm._v("蟠桃：")]), _vm._v(" "), _c('span', {
    staticClass: "fs-42"
  }, [_vm._v(_vm._s(_vm.scoreInfo.score))])]), _vm._v(" "), _c('span', {
    staticClass: "scoreBtn",
    class: {
      'signed': _vm.scoreInfo.sign_status == 1
    }
  }, [_vm._v(_vm._s(_vm.scoreInfo.sign_status == 1 ? '今日已签到' : '签到领积分'))])]), _vm._v(" "), (_vm.showRecommend) ? _c('div', {
    staticClass: "recommend",
    style: ({
      backgroundImage: 'url(' + _vm.bannerUrl + ')'
    }),
    on: {
      "click": _vm.toRecommend
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list order-list"
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "padding-top": ".32rem"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toAddressList
    }
  }, [_c('span', {
    staticClass: "icon1 icon_adress fl"
  }, [_vm._v("我的地址")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyComment
    }
  }, [_c('span', {
    staticClass: "icon1 icon_comments fl"
  }, [_vm._v("我的评论")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyComplaints
    }
  }, [_c('span', {
    staticClass: "icon1 icon_complaints fl"
  }, [_vm._v("我的投诉")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyService
    }
  }, [_c('span', {
    staticClass: "icon1 icon_cs fl"
  }, [_vm._v("客服中心")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.toMyCoupons
    }
  }, [_c('span', {
    staticClass: "icon1 icon_coupons fl"
  }, [_vm._v("我的优惠券")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding-bottom": ".32rem"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toShare
    }
  }, [_c('span', {
    staticClass: "icon1 icon_share fl"
  }, [_vm._v("邀请有礼")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]), _vm._v(" "), (!_vm.isJdlwHide) ? _c('li', [_c('a', {
    staticStyle: {
      "border-bottom": "none",
      "border-top": "1px solid #F5F5F5",
      "padding": ".55rem 0 .54rem 0"
    },
    on: {
      "click": _vm.loginOut
    }
  }, [_c('span', {
    staticClass: "icon1 icon_logout fl"
  }, [_vm._v("退出登录")]), _c('span', {
    staticClass: "icon_arrow_next fr"
  })])]) : _vm._e()])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ed834c44","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/UserCenter.vue
// module id = 463
// module chunks = 7